const Devops = theme => {
  return {
    background: {
      backgroundImage:
      'linear-gradient(to right top, #ea3b4c, #e3475b, #db5268, #d15c73, #c6667c)',
    },
    foreground: {
      color: 'rgba(255,255,255,.7)'
    },
    from: '#ea3b4c',
    to: '#c6667c',
  }
}

export default Devops



// WEBPACK FOOTER //
// ./src/styles/mixins/gradients/devops.js